module.exports = __webpack_public_path__ + "static/img/pic_ai_video_2.d3d01d6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic_ai_video_2.gif
// module id = Avma
// module chunks = 1